import React, { useContext, useEffect, useState } from 'react';
import { CiEdit } from 'react-icons/ci';

import SearchableDropDownCodeMozoee from '../../../SearchableDropDown/SearchableDropDownCodeMozoee.tsx';
import { DataContext } from '../../../context/DataProvider.tsx';
import { IoNewspaperOutline } from 'react-icons/io5';

const CardMozoatMonaghah = () => {
  const {
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    titleSubInfo,
    setTitleSubInfo,
    toggleSabt,
    setToggleSabt,
    typeIdTitSub,
  } = useContext(DataContext);

  // console.log('typeIdTitSub',     titleSubInfo);
  useEffect(() => {
    return () => {};
  }, [titleSubInfo, titleSubInfo.ID, titleSubInfo.Type_ID]);

  const newSubFun = () => {
    try {
      setTitleSubInfo((prev) => ({
        ...prev,
        ID: 0,
        Title: '',
        Parent_ID: 0,

        Code: '',
        Ordering: '',
        Type_ID: 0,
        Keywords: '',
        Definition: '',

        MainLaw_IDs: '',

        IsActive: false,
        isChecked: false,
      }));
    } catch (error) {
      console.log('error', error);
    }
  };

  const upsertSubFun = async () => {
    if (!validateTitle(titleSubInfo.Title)) {
      // alert('لطفا عنوان را به درستی وارد نمایید');
      alert(
        'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
      );
      return;
    }
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/Subject/Upsert`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            id: titleSubInfo.ID,
            title: titleSubInfo.Title,
            parent_ID: titleSubInfo.Parent_ID,
            definition: titleSubInfo.Definition,
            code: titleSubInfo.Code,
            ordering: titleSubInfo.Ordering,
            type_ID: titleSubInfo.Type_ID,
            keywords: titleSubInfo.Keywords,
            old_IDs: titleSubInfo.Old_IDs,
            mainLaw_IDs: titleSubInfo.MainLaw_IDs,
            section_ID: titleSubInfo.Section_ID,
            isActive: titleSubInfo.IsActive,
            isChecked: titleSubInfo.isChecked,
          }),
        }).then((res) => {
          console.log('=========>', res.json());
          setToggleSabt(!toggleSabt);
          if (res.status === 200) {
            alert('ویرایش با موفقیت انجام شد');

            setTitleSubInfo((prev) => ({
              ...prev,
              ID: 0,
              Title: '',
              Parent_ID: 0,

              Keywords: '',
              Definition: '',

              Code: '',
              Ordering: '',
              Type_ID: 0,

              MainLaw_IDs: '',

              IsActive: false,
              isChecked: false,
            }));
          }
        });
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
      // alert('برای شما دسترسی جدید صادر گردید، لطفا مجددا تلاش نمایید');
    }
  };

  // یک تابع برای اعتبارسنجی عنوان
  const validateTitle = (title: string) => {
    // حذف فضاهای خالی از ابتدا و انتها
    const trimmedTitle = title.trim();

    // چک کردن کاراکترهای غیرمجاز
    const invalidChars = /[,!@#$%^&)(_+-./\\]/;

    if (!trimmedTitle || invalidChars.test(trimmedTitle)) {
      return false;
    }
    return true;
  };

  return (
    <>
      <div className="card-with-scroll col-span-3 pb-10">
        <div className="w-full flex items-center justify-center">
          {/* <ButtonsTopLeft /> */}
          <div className="w-full  text-center mb-2 bg-[#88b1a1] p-2 rounded-lg">
            <p className="font-IranSans text-sm text-white">
              <b> ویرایش کدهای موضوعی </b>
            </p>
            <p className="font-IranSans mr-3 text-sm">
              {/* <b> {tota ? tota : ""}</b> */}
            </p>
          </div>
        </div>
        {/* <BoxContentDastgahEjraee /> */}
        <div className="max-w-full mx-auto ">
          <div className="border-b border-gray-200 dark:border-gray-700 mb-4">
            {/* <BottomButtons /> */}
          </div>
          {/* <div className="ModalBackground"> */}
          {/* <div className="Modal-innerSpLaw"> */}
          {/* <FaRegWindowClose
                // onClick={() => setOpenCreateModal(false)}
                className="  mb-2 cursor-pointer"
                size={18}
              /> */}
          <div className="w-full border rounded-md p-5 border-[#cbd5e1]">
            <div className="w-full grid grid-cols-2 gap-10 mt-5 ">
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  عنوان
                </label>
                {/* <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  // value={titSubID.Title}
                  value={titleSubInfo.Title}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                    }))
                  }
                /> */}
                {/* // تغییر در onChange عنوان */}
                <input
                  type="text"
                  className="w-full border outline-none p-2 rounded-md"
                  value={titleSubInfo.Title}
                  onChange={(e) => {
                    // const newTitle = e.target.value;
                    // if (validateTitle(newTitle)) {
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                      // Title: newTitle,
                    }));
                    // } else {
                    //   alert(
                    //     'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
                    //   );
                    // }
                  }}
                />
              </div>

              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  ترتیب
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titleSubInfo.Ordering}
                  // value={}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Ordering: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  کد
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titleSubInfo.Code}
                  // value={}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Code: e.target.value,
                    }))
                  }
                />
              </div>

              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  نوع شناسه
                </label> */}
              {/* <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titleSubInfo.Type_ID}
                  // value={}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Type_ID: e.target.value,
                    }))
                  }
                /> */}
              {/* <SearchableDropDownTypeID /> */}
              {/* </div> */}

              {/* <div className="flex flex-col gap-1 mt-4"> */}
              <div className="w-full flex items-center  col-span-1	">
                {/* <label htmlFor="hs-hidden-select" className="text-gray-700 "> */}
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  {' '}
                  نوع
                </label>
                <div
                  //  className="relative"
                  className="w-full border  outline-none  p-2 rounded-md"
                >
                  <select
                    // {...register('Subject')}
                    // value={titleSubInfo.Type_ID}
                    defaultValue={
                      titleSubInfo.Type_ID !== null
                        ? typeIdTitSub.filter(
                            (item) => item.id == titleSubInfo.Type_ID,
                          )[0] !== undefined
                          ? typeIdTitSub.filter(
                              (item) => item.id == titleSubInfo.Type_ID,
                            )[0]?.id
                          : null
                        : null
                    }
                    onChange={(e) =>
                      setTitleSubInfo((caseData) => ({
                        ...caseData,
                        Type_ID: Number(e.target.value),
                      }))
                    }
                    className=" w-full "
                  >
                    <option
                      className="font-extralight "
                      // selected
                      hidden
                      // value={0}
                    >
                      {/* value= */}
                      {titleSubInfo.Type_ID !== null
                        ? typeIdTitSub.filter(
                            (item) => item.id == titleSubInfo.Type_ID,
                          )[0]?.item
                        : '  انتخاب کنید '}
                      {/* انتخاب کنید */}
                    </option>
                    {typeIdTitSub ? (
                      typeIdTitSub.map((item) => {
                        return (
                          <option
                            className="font-extralight "
                            key={item.id}
                            value={item.id}
                          >
                            {item.item}
                          </option>
                        );
                      })
                    ) : (
                      <div>...</div>
                    )}
                  </select>
                </div>
              </div>

              <div className="w-full flex items-center justify-between mb-3">
                <label className="h-full w-[15%] text-[14px] flex items-start justify-start font-IranSans">
                  سرشاخه
                </label>
                <SearchableDropDownCodeMozoee />
              </div>

              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه های قوانین قبلی
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titleSubInfo.Old_IDs}
                  // value={}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Old_IDs: e.target.value,
                    }))
                  }
                />
              </div> */}

              <div className="w-full flex items-center justify-between">
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-checkbo"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    فعال است{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitleSubInfo((caseData) => ({
                        ...caseData,
                        IsActive: e.target.checked,
                      }))
                    }
                    id="default-checkbo"
                    type="checkbox"
                    checked={titleSubInfo.IsActive}
                    // value={titleSubInfo.IsActive}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-checkbox"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    تایید شده{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitleSubInfo((caseData) => ({
                        ...caseData,
                        isChecked: e.target.checked,
                      }))
                    }
                    id="default-checkbox"
                    type="checkbox"
                    checked={titleSubInfo.isChecked}
                    // value={titleSubInfo.isChecked}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه های قوانین شاخص
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={
                    titleSubInfo.MainLaw_IDs === null
                      ? ''
                      : titleSubInfo.MainLaw_IDs
                  }
                  // value={}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      MainLaw_IDs: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="w-full flex items-center  col-span-1	mb-1">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  تعریف
                </label>
                <textarea
                  value={titleSubInfo.Definition}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Definition: e.target.value,
                    }))
                  }
                  // name=""
                  rows={4}
                  className="w-full border  outline-none  p-2 rounded-md"
                  // className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  // placeholder="Write your thoughts here..."
                  // id=""
                ></textarea>
                {/* <input
                type="text"
                className="w-full border  outline-none  p-2 rounded-md"
                // value={}
                // onChange={(e) =>
                //   setcaseData((caseData) => ({
                //     ...caseData,
                //     title: e.target.value,
                //   }))
                // }
              />
                */}
              </div>
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  کلید واژه ها
                </label>
                <textarea
                  value={titleSubInfo.Keywords}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Keywords: e.target.value,
                    }))
                  }
                  // name=""
                  rows={4}
                  className="w-full border  outline-none  p-2 rounded-md"
                  // className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  // placeholder="Write your thoughts here..."
                  // id=""
                ></textarea>
                {/* <input
                type="text"
                className="w-full border  outline-none  p-2 rounded-md"
                // value={}
                // onChange={(e) =>
                //   setcaseData((caseData) => ({
                //     ...caseData,
                //     title: e.target.value,
                //   }))
                // }
              /> */}
              </div>
            </div>
            <div className="w-full h-full flex items-center ltr gap-5 mt-10">
              <button
                onClick={upsertSubFun}
                className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
              >
                ثبت
                <CiEdit size={25} className="ml-2" />
              </button>
              <button
                onClick={newSubFun}
                className="w-32 p-2 rounded-full text-[16px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans"
              >
                جدید <IoNewspaperOutline className="ml-3" />
              </button>
              {/* <button
                    className="w-32 p-2  font-IranSans rounded-full text-[16px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  >
                    حذف
                    <MdDeleteForever className="ml-3" />
                  </button> */}
            </div>
          </div>
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default CardMozoatMonaghah;
